import './index.less';
import PageView from './PageView';

PageView.install = function(Vue) {
  Vue.component(PageView.name, PageView);
};

export default PageView;
